import { config } from '../../config/config';
import { Observable } from 'rxjs';
import { utilService } from '../utils';

/**
 * Api services for posts component
 */
export const postService = {
  addPost,
  getGroups,
  getPostById,
  updatePost,
  deletePost,
  getPostsSignedUrl,
  fetchPostsBySignedUrl
};

function addPost(payload) {
  return Observable.create((observer) => {
    fetch(config.api_url + config.url.posts, {
      method: 'POST',
      headers: {
        Authorization: payload.token,
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(payload.data),
    })
      .then(utilService.handleResponse)
      .then((result) => {
        // console.log('result....', result)
        observer.next(result);
        observer.complete();
      })
      .catch((error) => {
        console.log(error);
        if (error.status === 401) {
          window.location.reload();
        } else {
          observer.error(error.responceObject.userMessage);
        }
      });
  });
}

function updatePost(payload) {
  // console.log('service payload....', payload)
  return Observable.create((observer) => {
    fetch(config.api_url + config.url.posts + payload.data.postUid, {
      method: 'PUT',
      headers: {
        Authorization: payload.token,
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(payload.data),
    })
      .then(utilService.handleResponse)
      .then((result) => {
        // console.log('result....', result)
        observer.next(result);
        observer.complete();
      })
      .catch((error) => {
        if (error.status === 401) {
          window.location.reload();
        }
      });
  });
}

function deletePost(payload) {
  return Observable.create((observer) => {
    fetch(config.api_url + config.url.posts + payload.id, {
      method: 'DELETE',
      headers: {
        Authorization: payload.token,
        'Content-Type': 'application/json',
      },
    })
      .then(utilService.handleResponse)
      .then((result) => {
        // console.log('result....', result)
        observer.next(result);
        observer.complete();
      })
      .catch((error) => {
        if (error.status === 401) {
          window.location.reload();
        }
      });
  });
}

function getPostById(payload) {
  return Observable.create((observer) => {
    fetch(config.api_url + config.url.posts + payload.id, {
      method: 'GET',
      headers: {
        Authorization: payload.token,
        'Content-Type': 'application/json',
      },
    })
      .then(utilService.handleResponse)
      .then((result) => {
        // console.log('result....', result)
        observer.next(result);
        observer.complete();
      })
      .catch((error) => {
        if (error.status === 401) {
          window.location.reload();
        }
      });
  });
}

function getGroups(token) {
  return Observable.create((observer) => {
    fetch(config.api_url + config.url.groups, {
      method: 'GET',
      headers: {
        Authorization: token,
      },
    })
      .then(utilService.handleResponse)
      .then((result) => {
        // console.log('result....', result)
        observer.next(result);
        observer.complete();
      })
      .catch((error) => {
        if (error.status === 401) {
          window.location.reload();
        }
      });
  });
}

function getPostsSignedUrl(data) {
  return Observable.create((observer) => {
    fetch(config.api_url + config.url.posts + data.params, {
      method: 'GET',
      headers: {
        Authorization: data.token,
      },
    })
      .then(utilService.handleResponse)
      .then((result) => {
        // console.log('result....', result)
        observer.next(result);
        observer.complete();
        // return result.responceObject.records
      })
      .catch((error) => {
        if (error.status === 401) {
          window.location.reload();
        }
      });
  });
}

function fetchPostsBySignedUrl(data) {
  return Observable.create((observer) => {
    fetch(data.url, {
      method: 'GET',      
    })
      .then(utilService.handleResponse)
      .then((result) => {
        // console.log('result....', result)
        observer.next(result);
        observer.complete();
        // return result.responceObject.records
      })
      .catch((error) => {
        if (error.status === 401) {
          // window.location.reload();
        }
      });
  });
}
